<template>
  <v-container>
    <v-layout column justify-center>
      <v-flex xs12 sm6>
        <v-card class="mt-5">

          <v-card-title v-if="orderData">
            <div class="subheading blue--text"><span  class="black--text">Progress:</span> {{progress}}</div>
          </v-card-title>

          <v-card-title v-if="orderData">
              <v-text-field
                  v-model="orderData.label"
                  append-outer-icon="check"
                  prepend-icon="label"
                  color="blue"
                  @click:append-outer="updateOrder"
              ></v-text-field>
          </v-card-title>
          <v-toolbar dense flat>
            <v-btn rounded small outlined @click="duplicateBooking">Duplicate Booking</v-btn>
            <v-spacer></v-spacer>
            <v-btn outlined @click="resetPanels">Reset Panel</v-btn>
          </v-toolbar>
          <v-expansion-panels multiple v-model="expansionPanel">
            <v-expansion-panel>
              <v-expansion-panel-header class="success">
                <div class="headline white--text">Order Detail</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <order-app :id="id"></order-app>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="blue">
                <div class="headline white--text">Dispatch</div>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                  <div v-if="orderData" class="mt-3">
                    <dispatch-app :id="id"></dispatch-app>
                    </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header class="pink">
                <div class="headline white--text">Fulfillment</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <fulfillment-app  :id="id"></fulfillment-app>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="mt-3">
        <v-btn block
               outlined
               text
               class="error--text"
               @click="openDeleteModal = true"
        >delete</v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="openDeleteModal"
              ref="dialog"
              persistent
              width="290px"
    >

      <v-card>
        <v-card-title>
          <div class="white black--text
                    text-xs-center
                    font-weight-thin display-1">Delete Order</div>
        </v-card-title>
        <v-card-title>
          This order will be deleted forever.
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="openDeleteModal = false">cancel</v-btn>
          <v-btn @click="deleteSale" class="error">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from 'moment'
import {doc, deleteDoc, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import {v1 as uuidv1} from "uuid";
export default {
  props:["id"],
  data () {
    return {
      openDeleteModal: false,
      orderData: undefined,
      schedulingData: undefined,
      fulfillmentData: undefined,
      expansionPanel: [0],
      dispatchData: undefined,
      status: null,
      eventDateTimeDialog: false,
      time: null,
      date: null
    }
  },
  created() {
    let db = this.$store.state.db
    let salesRef = doc(db, 'users', this.user.uid, 'orders', this.id)
    let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', this.id)
    // let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', this.id)
    onSnapshot(salesRef, res => {
      if (res.exists) {
        let data = res.data()
        if (data.status === 'warning') {
          this.expansionPanel = [0]
          // console.log(res)
        }
        if (data.status === 'success') {
          this.expansionPanel = [1]
          // console.log(res)
        }
        if (data.progress) {
          let sorted = data.progress.sort((a, b) => {
            return b.created - a.created
          })
          this.progress = sorted[0].title
        } else {
          this.progress = 'Order Created'
        }
        this.orderData = res.data()
        if (!data.label) {
          this.orderData.label = data.id
          // console.log(res)
        }
        if(data.fulfillmentInfo.date) {
          // console.log(data.fulfillmentInfo.date)
          this.date = data.fulfillmentInfo.date
        }

        if(data.fulfillmentInfo.estimatedFinishTime) {
          this.time = data.fulfillmentInfo.estimatedFinishTime
        } else {
          if (data.status === 'success') {
            this.eventDateTimeDialog = true
          }
        }
        // console.log(res.data())
      }
    })
    onSnapshot(dispatchRef, res => {
      if (res.exists) {
        if (res.data().status === 'success') {
          this.expansionPanel = [2]
        }
        this.dispatchData = res.data()
        // console.log(res.data())
      }
    })
    // onSnapshot(fulfillmentRef, res => {
    //   if (res.exists) {
    //     if (res.data().status === 'success') {
    //       this.expansionPanel = [0]
    //     }
    //     // this.dispatchData = res.data()
    //     //console.log(res.data())
    //   }
    // })

  },
  computed: {
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do')
        return day
      }
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    deleteSale() {
      this.openDeleteModal = false
      let db = this.$store.state.db
      let salesRef = doc(db, 'users', this.user.uid, 'orders', this.id)
      let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', this.id)
      let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', this.id)
      deleteDoc(salesRef)
          .then(() => {
            return deleteDoc(dispatchRef)
          })
          .then(() => {
            return deleteDoc(fulfillmentRef)
          })
          .then(() => {
            //console.log(order)
            this.$router.push('/bookings')
          })
          .catch(err => [
            this.$store.dispatch('setError', err)
          ])
      //this.$router.push('/sale/' + order.id)
    },
    updateOrder() {
      let db = this.$store.state.db
      let orderRef = doc(db, 'users', this.user.uid + '/orders/' + this.id)
      console.log(this.orderData)
      updateDoc(orderRef, this.orderData)
          .catch(err => {
            this.$store.dispatch('setError', err)
          })
    },
    duplicateBooking () {
      // console.log(this.orderData)
      let order = {...this.orderData}
      delete order.id
      order.id = uuidv1()
      order.status = 'warning'
      order.created = Date.now()
      order.label = 'Duplicate: ' + order.id
      // console.log(order)
      if (order.remainingBalanceStatus) {
        delete order.remainingBalanceStatus
      }
      if (order.fulfillmentInfo.estimatedFinishTime) {
        delete order.fulfillmentInfo.estimatedFinishTime
      }
      order.payments.forEach(payment => {
        if (payment.status) {
          delete payment.status
        }
      })
      // console.log(order)
      let db = this.$store.state.db
      let salesRef = doc(db, 'users', this.user.uid, 'orders', order.id)
      let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', order.id)
      let fulfillmentRef = doc(db, 'users', this.user.uid, 'fulfillment', order.id)
      setDoc(salesRef, order)
          .then(() => {
            let dispData = {...this.dispatchData}
            dispData.status = 'warning'
            return setDoc(dispatchRef, dispData)
          })
          .then(() => {
            return setDoc(fulfillmentRef, {
              orderData: order,
              ETA: "",
              lastActive: {},
              status: 'warning'
            })
          })
          .then(() => {
            //console.log(order)
            this.$router.push('/bookings')
            this.newSaleDialog = false
          })
          .catch(err => [
            this.$store.dispatch('setError', err)
          ])
    },
    resetPanels () {
      let db = this.$store.state.db
      let salesRef = doc(db, 'users', this.user.uid, 'orders', this.id)
      let dispatchRef = doc(db, 'users', this.user.uid, 'dispatch', this.id)
      this.orderData.status = 'warning'
      this.dispatchData.status = 'warning'
      return updateDoc(salesRef, this.orderData)
          .then (() => {
            return updateDoc(dispatchRef, this.dispatchData)
          })

    },
    setEventToCalendar () {
      // console.log(this.time)
      this.eventDateTimeDialog = false
      let eventDate = new Date(this.orderData.fulfillmentInfo.date)
      let eventObj = {
        name: this.orderData.clientInfo.name,
        start: this.orderData.fulfillmentInfo.date + ' '
            + this.orderData.fulfillmentInfo.time
        ,
        end: this.orderData.fulfillmentInfo.date + ' '
            + this.orderData.fulfillmentInfo.estimatedFinishTime
        ,
        color: 'blue',
        timed: true,
        formattedStartDate: eventDate.getTime(),
        orderId: this.id
      }
      // console.log(this.orderData.fulfillmentInfo.date)
      // console.log(eventObj)
      let db = this.$store.state.db
      let scheduleRef =  doc(db, 'users', this.user.uid, 'schedule', this.id)
      let orderRef = doc(db, 'users', this.user.uid, 'orders', this.id)
      setDoc(scheduleRef, eventObj)
          .then (() => {
            return updateDoc(orderRef, this.orderData)
          })

    },
    openEventDateTimeDialog () {
      this.eventDateTimeDialog = true
    }
  }
}
</script>
